import { BaseTranslation } from '../../i18n-types';

export const slack: BaseTranslation = {
  oauth: {
    exchange: {
      loading: {
        title: 'Authenticating Slack',
        body1: "We are authenticating your account, please don't go anywhere.",
      },
      error: {
        title: 'Error Authenticating Slack',
        body1: 'We could not complete the Slack authentication.',
        noCodeError: 'We could not find a Slack code in the URL.',
        reauthenticate: 'Please try re-authenticating your account',
      },
      success: 'You have successfully connected your Slack workspace!',
    },
  },
  account: {
    reauthenticateText:
      'Your Slack Workspace needs to be re-authenticated by an owner or administrator of the account',
    reauthenticateLinkText: "via 'Workspace Settings'",
  },
  errors: {
    slack_account_is_inactive: 'Account is inactive',
    slack_channel_is_archived: 'Channel is archived',
    user_is_restricted_from_channel: 'Channel not found',
    default_account_error: 'Account is inactive',
    default_channel_error: 'Channel not found',
  },
};
